module.exports = __webpack_public_path__ + "e447e09e54b33ba9b8235abb5904fe62.svg";